import React, {useContext, useState} from 'react';
import {createRoot} from 'react-dom/client';
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import styles from './PageDomainBGCyr.scss'
import ComponentHeaderPublic from "../../components/ComponentHeaderPublic/ComponentHeaderPublic";
import {__t} from "../../common/lang/text-resource";
import whiteBox from "../../common/scss/WhiteBox.scss";
import headIMG from "./img/SH-bg-domains.png";
import {ContextServicePrice, ContextServicePriceProvider} from "../../context/ContextServicePriceProvider";
import DomainLabelNew from "../../common/primitives/DomainLabelNew";
import {FormatPrice} from "../../common/primitives/Price";
import YellowErrorBlock from "../../common/primitives/YellowErrorBlock";
import TextBox from "../../common/primitives/TextBox";
import ServicePriceSelect from "../../common/primitives/ServicePriceSelect";
import Button, {buttons} from "../../common/primitives/Button";
import ComponentFooter from "../../components/ComponentFooter/ComponentFooter";
import HoverTooltip, {HoverTooltipStyles} from "../../common/primitives/HoverTooltip";

class PageDomainBGCyr extends BaseComponent {

	constructor() {
		super(...arguments, 'PageBGDomain');
		SHVO.pageComponent = this;
		this.lang = SHVO.pageLang ?? 'bg';
	}


	render() {
		const {
			header,
			domLabels,
			priceTransfer,
			basePriceTransfer,
			selectOptions,
			selectOptionsTransfer
		} = this.props.data.componentData;

		const bgDomainPrice = selectOptions[0];
		return (
		  <>
			  <ComponentHeaderPublic data={header} isLazy={"1"}/>
			  <header className={styles.header}>
				  <div className={styles.innerHeader}>
					  <h1>{__t("Домейн .БГ")}</h1>
					  <h2>{__t('регистрирайте-или-трансферирайте-своя-BG-домейн-пe56bfe')}</h2>
				  </div>
			  </header>
			  <section role="main" className={styles.cont}>
				  <div className={styles.introContainer}>
					  <div className={`${whiteBox.container} ${styles.intro}`}>
						  <div>
							  <p>{__t('регистрацията-на-домейни-на-кирилица-в-областта-б14a8f4')}</p>

							  <p>{__t('С всеки регистриран .БГ домейн получавате:')}</p>
							  <ul>
								  <li>{__t('атрактивна цена')}</li>
								  <li>{__t('максимално улеснена регистрация;')}</li>
								  <li>{__t('право-да-регистрирате-същия-домейн-на-кирилица-в-5c825a')}</li>
							  </ul>
							  <small>{__t('-регистрацията-на-домейн-на-кирилица-от-областта-cb7d16')}</small>
						  </div>
						  <div>
							  <img src={headIMG} alt={__t('Домейн .BG')}/>
						  </div>
					  </div>
				  </div>
				  <div className={styles.formsContainer}>
					  <RegisterDomain
						selectOptions={selectOptions}
						ajaxCall={this.ajaxCall}/>

					  <TransferDomain
						selectOptions={selectOptionsTransfer}
						ajaxCall={this.ajaxCall}/>
				  </div>

				  <ContextServicePriceProvider>
					  <AdditionalServices/>
					  <Prices
						priceTransfer={priceTransfer}
						basePriceTransfer={basePriceTransfer}
						domLabels={domLabels}/>
				  </ContextServicePriceProvider>
			  </section>
			  <br/>
			  <br/>
			  <br/>
			  <br/>
			  <ComponentFooter/>
		  </>
		)
	}
}

const RegisterDomain = ({selectOptions, ajaxCall}) => {

	const [error, setError] = useState('');
	const [state, setState] = useState({domainName: '', selectedTLD: selectOptions[0]});

	const changeDomainName = (domainName) => {
		state.domainName = domainName;
		setState({...state});
	}

	const changeTLD = (tld) => {
		state.selectedTLD = tld;
		setState({...state});
	}

	const submitForm = () => {
		const ap = new AjaxParam();
		ap.callbackError = ({componentErrors}) => {
			setError(componentErrors[0]);
		}

		ajaxCall('ActionRegisterDomain', {...state}, ap);
	}
	return (
	  <div className={styles.form}>
		  <h2>{__t('Регистрация на домейн .БГ')}</h2>
		  <div className={whiteBox.container}>
			  {error !== '' && <>
				  <YellowErrorBlock error={error}/>
				  <br/>
			  </>}

			  <h4 data-layout="margin-top--none">{__t('Търсене на домейн име:')}</h4>
			  <FormInput
				changeDomainName={changeDomainName}
				changeTLD={changeTLD}
				domainName={state.domainName}
				selectedTLD={state.selectedTLD}
				submitForm={submitForm}
				selectOptions={selectOptions}
				buttonLabel={__t('Търсене')}
			  />

			  {__t('изберете-лесно-за-запомняне-и-изписване-име-без-с66eac1')}&nbsp;
			  <a href={__t('https://help.superhosting.bg/tips-choosing-domain.html')} target={'_blank'}
				 rel="noopener noreferrer">
				  {__t('"Съвети за избор на домейн"')}
			  </a>

		  </div>
	  </div>
	)
}

const TransferDomain = ({selectOptions, ajaxCall}) => {

	const [error, setError] = useState('');
	const [freeDomain, setFreeDomain] = useState('');
	const [state, setState] = useState({domainName: '', selectedTLD: selectOptions[0]});

	const changeDomainName = (domainName) => {
		state.domainName = domainName;
		setState({...state});
	}

	const changeTLD = (tld) => {

		state.selectedTLD = tld;
		setState({...state});
	}

	const submitForm = () => {
		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			setFreeDomain(componentData[0]);
		}
		ap.callbackError = ({componentErrors}) => {
			setError(componentErrors[0]);
		}

		ajaxCall('ActionTransferDomain', {...state}, ap);
	}

	const doTransferFreeDomains = () => {
		ajaxCall('ActionTransferFreeDomains', {domainName: freeDomain});
	}

	return (
	  <div className={styles.form}>
		  <h2>{__t('Трансфер на домейн .БГ')}</h2>
		  <div className={whiteBox.container}>
			  {error !== '' && <>
				  <YellowErrorBlock error={error}/>
				  <br/>
			  </>}
			  <h4 data-layout="margin-top--none">{__t('Прехвърляне и управление на домейн:')}</h4>

			  <FormInput
				changeDomainName={changeDomainName}
				changeTLD={changeTLD}
				domainName={state.domainName}
				selectedTLD={state.selectedTLD}
				submitForm={submitForm}
				selectOptions={selectOptions}
				buttonLabel={__t('Трансфер')}
			  />
			  {__t('за-повече-информация-за-трансфер-на-бг-домейн-мож54d196')}&nbsp;
			  <a href={__t('https://help.superhosting.bg/transfer-bg-domain.html')} target={'_blank'}
				 rel="noopener noreferrer">
				  {__t('"Трансфер на домейн от областта .BG"')}
			  </a>

		  </div>
		  {freeDomain !== '' &&
			<div className={styles.transferModal}>
				<div className={whiteBox.container}>
					<p>{__t('въведеният-домейн-не-е-регистриран-моля-проверете6ad954')}</p>
					<div className={styles.modalButtons}>
						<Button onClick={() => setFreeDomain('')} value={__t('Корекция на името')}/>
						<Button onClick={() => window.location = '/web-hosting-register-domains.php'}
								value={__t('Регистрация на домейн')}/>
						<Button onClick={doTransferFreeDomains} value={__t('Трансфер на домейна')}
								className={buttons.btnGray}/>
					</div>
				</div>
			</div>
		  }
	  </div>
	)
}

const FormInput = ({
					   domainName,
					   selectOptions,
					   selectedTLD,
					   changeTLD,
					   changeDomainName,
					   submitForm,
					   buttonLabel
				   }) => {
	return (
	  <div className={styles.formInput}>
		  <div>
			  <label>www.</label>
			  <div>
				  <TextBox
					name={`domain_name_register`}
					value={domainName}
					onChange={({target}) => changeDomainName(target.value)}
					placeholder={'mysupersite'}/>
			  </div>
			  <div className={styles.selectContainer}>
				  <ServicePriceSelect
					name={`price_select_register`}
					termCol={'selectLabel'}
					options={selectOptions}
					dontReverseOptions={true}
					selected={selectedTLD}
					hideDiscountCol={true}
					onChange={(selected) => changeTLD(selected)}
				  />
			  </div>
		  </div>
		  <div>
			  <Button
				value={buttonLabel}
				onClick={submitForm}
				className={`${buttons.btnPrimary} ${styles.transferButton}`}/>
		  </div>
	  </div>
	)
}

const Prices = ({priceTransfer, basePriceTransfer, domLabels}) => {
	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const prices = context.getVOForId('bgcyr');

	if (prices.length === 0) return;

	return (
	  <section className={styles.prices}>
		  <h2>{__t('Цени и периоди')}</h2>
		  <table>
			  <thead>
			  <tr>
				  <th>{__t('Период')}</th>
				  <th>{__t('цена за регистрация')}</th>
				  <th>{__t('цена за подновяване')}</th>
				  <th>{__t('цена за трансфер')}</th>
			  </tr>
			  </thead>
			  <tbody>
			  {prices.map(price => (
				<tr key={price.id}>
					<td>
						{price.term}
						{price.termClear === 12 && domLabels.length > 0 && domLabels.map(label => (
						  <DomainLabelNew
							key={label.name}
							text={label.name}
							backgroundColor={'#' + label.background_color}
							textColor={'#' + label.text_color}/>
						))}
					</td>
					<td>
						{price.priceNewFormatted}
						{parseFloat(price.priceNew) < parseFloat(price.basePriceNew) &&
						  <span
							className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceNew), price.currency)}</span>}
					</td>
					<td>
						{FormatPrice(parseFloat(price.priceRenew), price.currency)}
						{parseFloat(price.priceRenew) < parseFloat(price.basePriceRenew) &&
						  <span
							className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceRenew), price.currency)}</span>}
					</td>
					<td>
						{price.termClear === 12 ? FormatPrice(parseFloat(priceTransfer), price.currency) : '-'}
						{price.termClear === 12 && parseFloat(priceTransfer) < parseFloat(basePriceTransfer) &&
						  <span
							className={styles.oldPrice}>{FormatPrice(parseFloat(basePriceTransfer), price.currency)}</span>}
					</td>
				</tr>
			  ))}

			  </tbody>
		  </table>
	  </section>
	);
}

function OnMouseEnterCharName(ttpId) {
	if (document.getElementById(ttpId)) {
		document.getElementById(ttpId).style.display = 'inline-block';
	}
}

function OnMouseOutCharName() {
	const elems = document.getElementsByClassName(HoverTooltipStyles.container);

	[].forEach.call(elems, function (el) {
		el.style.display = 'none';
	});
}


const AdditionalServices = () => {
	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const prices = context.getForIds([
		'ho_srvc_01',
		'ho_srvc_02',
		'ho_srvc_03',
		'ho_srvc_04',
		'ho_srvc_05',
		'ho_srvc_06',
	]);

	if (prices.length === 0) return;

	return (
	  <section className={styles.prices}>
		  <h2>{__t('Допълнителни услуги, свързани с домейни от областта .БГ')}</h2>
		  <table>
			  <thead>
			  <tr>
				  <th>{__t('Услуга')}</th>
				  <th>{__t('цена с ДДС')}</th>
			  </tr>
			  </thead>
			  <tbody>
			  <tr>
				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp1`)}>
						  {__t('Заявка-промяна на собственост на домейн')}
					  </span>
					  <HoverTooltip
						tooltip={__t('настоящият-регистрант-на-домейна-изпраща-по-имейлb30d69')}
						name={`bgttp1`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_01[1].priceNew), prices?.ho_srvc_01[1].currency)}</td>
			  </tr>
			  <tr>

				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp2`)}>
						  {__t('Заявка-промяна на адреса за кореспонденция')}
					  </span>
					  <HoverTooltip
						tooltip={__t('регистрантът-на-домейна-изпраща-по-имейл-данните-8f19f5')}
						name={`bgttp2`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_02[1].priceNew), prices?.ho_srvc_02[1].currency)}</td>
			  </tr>
			  <tr>
				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp3`)}>
						  {__t('Заявка-промяна на името на регистранта')}
					  </span>
					  <HoverTooltip
						tooltip={__t('регистрантът-на-домейна-изпраща-по-имейл-данните-95b555')}
						name={`bgttp3`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_03[1].priceNew), prices?.ho_srvc_03[1].currency)}</td>
			  </tr>
			  <tr>
				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp4`)}>
						  {__t('Заявка-промяна на лицето за администр. контакт')}
					  </span>
					  <HoverTooltip
						tooltip={__t('регистрантът-на-домейна-изпраща-по-имейл-данните-9d5310')}
						name={`bgttp4`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_04[1].priceNew), prices?.ho_srvc_04[1].currency)}</td>
			  </tr>
			  <tr>
				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp5`)}>
						  {__t('Заявка-промяна на основание за ползване на домейн')}
					  </span>
					  <HoverTooltip
						tooltip={__t('регистрантът-на-домейна-изпраща-по-имейл-данните-f705f9')}
						name={`bgttp5`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_05[1].priceNew), prices?.ho_srvc_05[1].currency)}</td>
			  </tr>
			  <tr>
				  <td
					onMouseLeave={OnMouseOutCharName}>
					  <span onMouseOver={() => OnMouseEnterCharName(`bgttp6`)}>
						  {__t('Заявка-отказ от регистрацията на домейн')}
					  </span>
					  <HoverTooltip
						tooltip={__t('регистрантът-на-домейна-изпраща-по-имейл-декларац3269ab')}
						name={`bgttp6`}/>
				  </td>
				  <td>{FormatPrice(parseFloat(prices?.ho_srvc_06[1].priceNew), prices?.ho_srvc_06[1].currency)}</td>
			  </tr>
			  </tbody>
		  </table>
	  </section>
	);
}
const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageDomainBGCyr data={SHVO.pageState} isLazy={'1'}/>);
